import { AGENT_DASHBOARD_ROUTES } from "replo-utils/lib/dashboardRoutes";

export type EditorRoute = {
  projectId: string;
  elementId?: string;
  productId?: string;
};

export const routes = {
  signup: "/auth/signup",
  home: {
    root: "/home",
    shareTemplate: "/home/template/:templateId",
  },
  error: {
    noAccess: "/error/no-access",
  },
  shopify: {
    install: "/shopify/install",
  },
  allProjects: "/shops/all",
  editor: {
    project: "/editor/:projectId",
    element: "/editor/:projectId/:elementId",
    settings: "/editor/:projectId/project-settings",
    integrations: "/editor/:projectId/integrations",
  },
  workspace: {
    projects: "/workspace/:workspaceId/projects",
    integrations: {
      list: "/workspace/:workspaceId/integrations",
      shopify: "/workspace/:workspaceId/integrations/shopify",
    },
    billing: "/workspace/:workspaceId/billing",
    experiments: {
      list: "/workspace/:workspaceId/abtesting",
      settings: "/workspace/:workspaceId/abtesting/settings",
      details: "/workspace/:workspaceId/abtesting/:experimentId/details",
      results: "/workspace/:workspaceId/abtesting/:experimentId/results",
      edit: "/workspace/:workspaceId/abtesting/:experimentId/edit",
    },
    members: "/workspace/:workspaceId/members",
    settings: {
      general: "/workspace/:workspaceId/settings/general",
      members: "/workspace/:workspaceId/settings/members",
      billing: "/workspace/:workspaceId/settings/billing",
      account: {
        profile: "/workspace/:workspaceId/settings/account/profile",
        referrals: "/workspace/:workspaceId/settings/account/referrals",
      },
    },
  },
  analytics: {
    overview: "/workspace/:workspaceId/analytics/overview",
    pageDetails: "/workspace/:workspaceId/analytics/deep-dive",
    insights: "/workspace/:workspaceId/analytics/insights",
    home: "/workspace/:workspaceId/analytics/home",
  },

  /* NOTE (Craig, 2025-05-06): This is the new shops layout routes. */
  shareTemplate: "/template/:templateId",
  share: {
    page: "/share/page/:templateId",
    agent: "/share/agent/:shareId",
    registry: "/share/registry/:itemId",
  },
  agent: AGENT_DASHBOARD_ROUTES,
  shops: {
    default: "/shops",
    all: "/shops/all",
    root: "/shops/:projectId",
    site: "/shops/:projectId/site",
    home: "/shops/:projectId/home",
    chat: "/shops/:projectId/chat",
    analytics: {
      overview: "/shops/:projectId/analytics/overview",
      pageDetails: "/shops/:projectId/analytics/deep-dive",
      insights: "/shops/:projectId/analytics/insights",
      home: "/shops/:projectId/analytics/home",
    },

    settings: {
      account: {
        profile: "/shops/:projectId/settings/account/profile",
        referrals: "/shops/:projectId/settings/account/referrals",
      },
      shops: {
        general: "/shops/:projectId/settings/shop/general",
        fonts: "/shops/:projectId/settings/shop/fonts",
        scripts: "/shops/:projectId/settings/shop/scripts",
        integrations: {
          home: "/shops/:projectId/settings/shop/integrations",
          edit: "/shops/:projectId/settings/shop/integrations/:integrationId/edit",
        },
        abtesting: "/shops/:projectId/settings/shop/abtesting",
        analytics: "/shops/:projectId/settings/shop/analytics",
        advanced: "/shops/:projectId/settings/shop/advanced",
      },
      workspace: {
        general: "/shops/:projectId/settings/workspace/general",
        members: "/shops/:projectId/settings/workspace/members",
        billing: "/shops/:projectId/settings/workspace/billing",
      },
    },
    experiments: {
      list: "/shops/:projectId/abtesting",
      details: "/shops/:projectId/abtesting/:experimentId/details",
      results: "/shops/:projectId/abtesting/:experimentId/results",
      edit: "/shops/:projectId/abtesting/:experimentId/edit",
    },
    editor: {
      root: "/shops/:projectId/editor",
      element: "/shops/:projectId/editor/:elementId",
      settings: "/shops/:projectId/editor/project-settings",
      integrations: "/shops/:projectId/editor/integrations",
    },
    growthAudits: "/shops/:projectId/growth-audits",
    styleExtraction: "/shops/:projectId/style-extraction",
    designLibrary: "/shops/:projectId/design-library",
    products: {
      list: "/shops/:projectId/products",
      edit: "/shops/:projectId/products/:productId/edit",
      new: "/shops/:projectId/products/new",
    },
  },
  onboarding: {
    default: "/onboarding",
    billing: "/onboarding/billing",
    userInfo: "/onboarding/user-info",
    agentBilling: "/onboarding/agent-billing",
  },
  externalIntegrations: {
    hootsuite: "/external-integrations/hootsuite",
  },
  cliAuth: "/cli-auth",
};

const PUBLIC_SHARE_PATH_PREFIXES = [
  "/share/page/",
  "/share/agent/",
  "/share/registry/",
] as const;

export function isPublicSharePath(pathname: string) {
  return PUBLIC_SHARE_PATH_PREFIXES.some((prefix) => {
    return pathname.startsWith(prefix);
  });
}
